import { Column, Divider, MainFormContent, SectionTitle, SimpleField, TitleContainer } from '@beacharound/beacharound-ui';
import { getAddressString } from '@beacharound/beacharound-ui-helpers';
import React, { Fragment } from 'react';

export default function DetailUserSection({user}) {
    if(!user) {
        return <Fragment></Fragment>
    }
    return (
        <Fragment>
            <TitleContainer>
                <SectionTitle text="Dati utente" />
            </TitleContainer>
            <Column>
                <MainFormContent flex>
                    <SimpleField
                        label="Nome"
                        value={`${user.profile?.firstName} ${user.profile?.lastName}`}
                        half
                    />
                    <SimpleField
                        label="Telefono"
                        value={user.profile?.phone}
                        half
                    />
                    <SimpleField
                        label="Email"
                        value={user.emails?.[0]?.address}
                    />
                    {user.profile?.address &&
                        <SimpleField
                            label="Indirizzo"
                            value={getAddressString(user.profile?.address)}
                        />
                    }
                </MainFormContent>
            </Column>
            <Divider />
        </Fragment>
    )
}